import { PermissionModel } from '../apis';
import store from '../store';
import _ from 'lodash';


export const getPermissions = (): PermissionModel[] => store.getters.permissions;

export const hasPermission = (val?: { context: string, action: string }) => {
  if (!val) return true;
  const { context, action } = val;
  // console.log(" context", context);
  // console.log("action ", action);
  const permissions = getPermissions();
  if (!context || !action || _.isEmpty(permissions)) {
    return true;
  }
  const filteredPermission = permissions.filter(p => p.code === context);
  if (_.isEmpty(filteredPermission)) {
    return false;
  }
  for (const permission of filteredPermission) {
    if (_.isEmpty(permission.action)) {
      continue;
    }
    if (permission.action.includes(action)) {
      return true;
    }
  }
  return false;
};

function lacksPermission(permission) {
  return !hasPermission(permission);
}

function hasAnyPermissions(permissions) {
  if (!permissions || !permissions.length) return true;
  const userPermissions = getUserPermissions();
  if (!userPermissions || !userPermissions.length) return false;
  return permissions.some(perm => hasUserPermissions(userPermissions, perm));
}

function hasAllPermissions(permissions) {
  if (!permissions || !permissions.length) return true;
  const userPermissions = getUserPermissions();
  if (!userPermissions || !userPermissions.length) return false;
  return permissions.every(perm => hasUserPermissions(userPermissions, perm));
}

function hasUserPermissions(userPermissions, perm) {
  return userPermissions.includes(perm);
}

function getUserPermissions() {
  return [];
}

function hasRole(role) {
  if (!role) return true;
  if (typeof role === 'string') {
    role = [role];
  }
  return hasAnyRoles(role);
}

function lacksRole(role) {
  return !hasRole(role);
}

function hasAnyRoles(roles) {
  if (!roles || !roles.length) return true;
  const userRoles = getUserRoles();
  if (!userRoles || !userRoles.length) return false;
  return roles.some(perm => userRoles.includes(perm));
}

function hasAllRoles(roles) {
  if (!roles || !roles.length) return true;
  const userRoles = getUserRoles();
  if (!userRoles || !userRoles.length) return false;
  return roles.every(perm => userRoles.includes(perm));
}

function getUserRoles() {
  return [];
}

export default {
  // called by Vue.use(FirstPlugin)
  install(Vue, options) {
    const accessFuncs = { hasPermission, lacksPermission, hasAnyPermissions, hasAllPermissions, hasRole, lacksRole, hasAnyRoles, hasAllRoles };

    Object.keys(accessFuncs).forEach(funcName => {
      const func: Function = accessFuncs[funcName];
      Vue.prototype['$' + funcName] = (v) => func(v);

      // Vue.directive(funcName, {
      //   inserted: (el, binding, vnode) => {
      //     if (!func(binding.value)) {
      //       if (vnode.elm && vnode.elm.parentElement) {
      //         vnode.elm.parentElement.removeChild(vnode.elm);
      //       }
      //       // if (el.parentNode) {

      //       //   el.parentNode.removeChild(el);
      //       // }
      //       else {
      //         el.style.setProperty('display', 'none', 'important');
      //       }
      //     }
      //   }
      // });
    });
  },
};
